import { toJS } from "mobx";
import get from "lodash/get";
import isArray from "lodash/isArray";

// Check is a column is sortable
// Usually it is configured as column.sortable, but for multiple data points we need to find the sortable one
export const isSortableColumn = (column) => {
    const { sortable = false, data } = column;

    if (isArray(toJS(data))) {
        const columnData = data.find(d => d.sortable) || data[0];
        return get(columnData, 'sortable', false);
    }

    return sortable;
};

export default isSortableColumn;


// WEBPACK FOOTER //
// ./src/utils/isSortableColumn.ts